import { useParams } from 'react-router-dom'
import EnhancedNavTabs from '@common/components/Tab/EnhancedNavTabs'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { createQCTabItems } from './tabs'
import { Divider } from '@mui/material'

export default function QCDetailsTabs() {
  const { studyId, qcTaskId } = useParams()
  const { hasAnyPermission } = useCombinedPermissions()

  const qcTabItems = createQCTabItems(studyId!, qcTaskId!)

  const filteredTabRoutes = qcTabItems
    .filter((item) => !item.permissions || hasAnyPermission(item.permissions))
    .map((item) => item.route)

  return (
    <>
      <EnhancedNavTabs routes={filteredTabRoutes} />
      <Divider />
    </>
  )
}
